import { CONSULTATION_KIND_LABEL } from "@/api/manual/consultation";
import { ManualHeadings } from "@/api/manual/headings";
import { ManualRules } from "@/api/manual/rules";
import type { ManualCover } from "@/api/manual/schema";

export function DocumentCover({ patient }: { patient: ManualCover }) {
	return (
		<header className="cover">
			<p className="cover-clinic">
				<span>{ManualRules.doctorContact.name}</span>
				<span>{ManualHeadings.coverClinicSuffix}</span>
			</p>

			<h1>
				{ManualHeadings.coverTitle[0]}
				<br />
				{ManualHeadings.coverTitle[1]}
			</h1>

			<p className="cover-name">{patient.name}</p>

			<p className="cover-consultation">
				<span>Consulta {CONSULTATION_KIND_LABEL[patient.consultation.kind]}</span>
				<span>{patient.consultation.date}</span>
			</p>
		</header>
	);
}

export function DocumentFooter() {
	const contact = ManualRules.doctorContact;

	return (
		<footer className="final-footer" contentEditable={false}>
			<p className="footer-name">{contact.name}</p>
			<p>{contact.crm}</p>
			<p>WhatsApp {contact.whatsapp}</p>
			<p>{contact.email}</p>
			<p>{contact.instagram}</p>
		</footer>
	);
}
